import React from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {Check, ChevronLeft} from 'lucide-react';
import Button from './Button';

// Sticky "‹ Retour · Titre · actions" bar of every create / edit page.
// "Enregistrer" is a plain teal header button on the far right; extra actions
// (`children`, e.g. an ActionMenu or another plain Button) go before it.
//
// back: route string (rendered as a Link) or a callback; defaults to history back.
// onSave: omit to hide the save button.

const FormHeader = ({
                        title,
                        back,
                        onSave,
                        saving = false,
                        saveDisabled = false,
                        saveLabel = 'Enregistrer',
                        children,
                    }) => {
    const navigate = useNavigate();
    const backProps = typeof back === 'string'
        ? {as: Link, to: back}
        : {onClick: back || (() => navigate(-1))};

    return (
        <header className="sticky top-0 z-30 flex items-center gap-2 sm:gap-4 px-3 sm:px-6 h-14 sm:h-16 border-b border-gray-200 dark:border-gray-700 bg-white/85 dark:bg-gray-900/85 backdrop-blur-xl">
            <div className="flex-1 min-w-0">
                <Button variant="ghost" icon={ChevronLeft} compact className="-ml-2" {...backProps}>
                    Retour
                </Button>
            </div>
            <h1 className="text-base sm:text-lg font-semibold text-center text-gray-800 dark:text-white truncate">
                {title}
            </h1>
            <div className="flex-1 min-w-0 flex items-center justify-end gap-1 sm:gap-2">
                {children}
                {onSave && (
                    <Button variant="plain" icon={Check} loading={saving} disabled={saveDisabled} onClick={onSave}>
                        {saveLabel}
                    </Button>
                )}
            </div>
        </header>
    );
};

export default FormHeader;
